import { toPlainText } from '@portabletext/react';
import { useNextSanityImage } from 'next-sanity-image';
import sanitizeHtml from 'sanitize-html';

import { getClient } from '@/lib/sanityUtils';

import type { CaseStudyType } from '@/types/shared';

interface CaseStudySchemaProps {
  url: string;
  datePublished: string;
  headline: CaseStudyType['heading'];
  postBody: CaseStudyType['postBody'];
  description: CaseStudyType['description'];
  image: CaseStudyType['featuredImage'];
  clientName: string;
}
const client = getClient();
const CaseStudySchema = ({
  url,
  datePublished,
  headline,
  postBody,
  description,
  image,
  clientName,
}: CaseStudySchemaProps) => {
  const imageProps = useNextSanityImage(client, image, {
    imageBuilder: (imageUrlBuilder, options) => {
      return imageUrlBuilder
        .width(
          options.width ||
            Math.min(options.originalImageDimensions.width, 1920),
        )
        .auto('format')
        .fit('clip');
    },
  });
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'NewsArticle',
          url,
          datePublished,
          headline: toPlainText(headline),
          articleBody: postBody && sanitizeHtml(toPlainText(postBody)),
          description: description && toPlainText(description),
          image: imageProps?.src && {
            '@type': 'ImageObject',
            url: imageProps.src,
            width: imageProps.width,
            height: imageProps.height,
          },
          creditText: clientName,
        }),
      }}
    />
  );
};

export { CaseStudySchema };
